export enum AddressType {
    None,
    Primary,
    Previous,
    Billing,
    Monitoring
}